var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isNotNetwork)?_c('div',{staticClass:"network"},[_c('i',{staticClass:"icon icon-error"},[_vm._v("!")]),_c('p',{staticClass:"network-content"},[_vm._v(" "+_vm._s(_setup.TUITranslateService.t("TUIConversation.网络异常，请您检查网络设置"))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }